export enum NOW_SLOT_TYPES {
  SAME_DAY = 'sameDay',
  NEXT_DAY = 'nextDay',
}

export interface NowSlot {
  slotId: string
  type: string
  deliveryDate: string
  deliveryDay: string
  start: string
  end: string
  secondsLeft: number
  timeString: string
  deliveryTimeInfo: string
  carrierName: string
  shippingCostsAmount: number
  preSelected: boolean
}

export type NowSlotPickup = Omit<
  NowSlot,
  'deliveryDate' | 'deliveryDay' | 'deliveryTimeInfo'
> & {
  pickupDate: string
  pickupDay: string
  pickupTimeInfo: string
}
